import { render } from "./CaretIcon.vue?vue&type=template&id=5bd668e0"
import script from "./CaretIcon.vue?vue&type=script&lang=js"
export * from "./CaretIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__